import { useCallback } from 'react';
import { Input } from 'reactstrap';
import styled from 'styled-components';

import { Label, LabeledData } from './menu-components';
import ReverseIcon from '../icons/ReverseIcon';
import { padOrTruncateArray } from '../../utils/utils';
import { useItemContext } from '../../contexts/ItemContext';
import { getRowId } from '../../utils/field';

// We bump the width of the label column here since the labels in the left-hand column take up more space in this component
const LabeledDataWider = styled(LabeledData)`
  ${Label} {
    min-width: 95px;
  }
`;

const RowOrderToggles = ({ section, updateFieldSection }) => {
  const { setActiveKey, clearActiveKey } = useItemContext();
  const firstRowId = getRowId(section.id, 0);

  const showFirstRow = useCallback(() => {
    setActiveKey(firstRowId);
  }, [setActiveKey, firstRowId]);

  const clearFirstRow = useCallback(() => {
    clearActiveKey();
  }, [clearActiveKey]);

  return (
    <>
      <LabeledDataWider
        label="flip row labels"
        icon={<ReverseIcon />}
        onMouseEnter={showFirstRow}
        onMouseLeave={clearFirstRow}
      >
        <Input
          type="checkbox"
          checked={section.rowOrderIsReversed ?? false}
          className="position-static m-0"
          onChange={() => {
            /**
             * NOTE: we flip `rowOrderIsReversed` but _also_ the row
             * overrides as well. This is because we just want the
             * numbering to flip, not the physical position of the
             * crop overrides. If we just flipped the rows, the crop
             * overrides would get moved.
             */

            const rowCount = section.rows.features.length;

            // Pad the overrides array with nulls to the full length of the rows, then reverse it
            const newRowOverrides = padOrTruncateArray(
              section.rowOverrides,
              rowCount,
            ).reverse();

            updateFieldSection(section.id, {
              rowOrderIsReversed: !section.rowOrderIsReversed,
              rowOverrides: newRowOverrides,
            });
          }}
        />
      </LabeledDataWider>

      <LabeledDataWider
        label="flip in-row labels"
        icon={<ReverseIcon vertical />}
        onMouseEnter={showFirstRow}
        onMouseLeave={clearFirstRow}
      >
        <Input
          type="checkbox"
          className="position-static m-0"
          onChange={() => {
            updateFieldSection(section.id, {
              orderWithinRowsIsReversed: !section.orderWithinRowsIsReversed,
            });
          }}
          checked={section.orderWithinRowsIsReversed ?? false}
        />
      </LabeledDataWider>
    </>
  );
};

export default RowOrderToggles;
